import React, { useContext } from 'react'
import { Box, Typography, Link } from '@mui/material'

import { usePageTitle } from 'apps/utils/usePageTitle'
import { ScreenContext } from 'apps/utils/ScreenContext'
import SectionShell from 'apps/common/SectionShell'
import theme from 'theme'

import { useStyles } from './styles'

const PentagonBadge = ( { classes, size = 'large', children } ) => (
	<Box
		component='span'
		className={ size === 'large' ? classes.pentagonBadgeLarge : classes.pentagonBadgeSmall }
		display='inline-flex'
		alignItems='center'
		justifyContent='center'
		verticalAlign='middle'
		bgcolor='var(--ink)'
		color='var(--bg)'
		fontWeight='700'
	>
		{ children }
	</Box>
)

// Fully static - the redesigned site has no backend-backed content, this
// page included. No member roster, no API call, no loading state.
const TeamList = () => {
	usePageTitle( 'Team — ACT Software' )
	const classes = useStyles()
	const { isLaptop, isLandscape } = useContext( ScreenContext )

	return (
		<SectionShell railLabel='Team'>
			<Box paddingRight={ theme.spacing( 6 ) }>
				<Typography variant='h1' textAlign='right' fontSize={ isLaptop ? '88px' : '60px' }>
					the team
				</Typography>
			</Box>
			<Box
				padding={ isLandscape ? '32px 104px 0 40px' : '24px 24px 0' }
			>
				<Typography fontSize={ 30 } marginBottom={ 3 }>
					In <PentagonBadge classes={ classes }>2016</PentagonBadge> we started as an independent team of enthusiasts.
				</Typography>
				<Typography fontSize={ 30 } marginBottom={ 3 }>
					Since <PentagonBadge classes={ classes }>2020</PentagonBadge> we are a proud part of the{ ' ' }
					<Link
						href='https://www.linkedin.com/company/amtoss/people/'
						target='_blank'
						rel='noopener noreferrer'
						color='inherit'
						sx={ { fontSize: '40px' } }
					>
						Amtoss team
					</Link>.
				</Typography>
				<Typography fontSize={ 24 } sx={ { lineHeight: 1.6 } }>
					The main asset of a software company is its engineering{ ' ' }
					<PentagonBadge classes={ classes } size='small'>team</PentagonBadge>.<br />
					The management role is to organize an ecosystem, a fertile garden where everyone who wants to improve can{ ' ' }
					<PentagonBadge classes={ classes } size='small'>grow</PentagonBadge>.<br />
					{ "Once you contact even a couple of us, you gain access to the whole team's knowledge due to the internal teamwork." }<br />
					Our <PentagonBadge classes={ classes } size='small'>30+</PentagonBadge> team is great and naturally growing professionally.
				</Typography>
			</Box>
		</SectionShell>
	)
}

export default React.memo( TeamList )
